"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Theme = (0, styles_1.createTheme)({
    palette: {
        primary: {
            main: "#1F263B",
            dark: "#00506E",
            contrastText: "#fff",
        },
        secondary: {
            main: "#FFF",
        },
        info: {
            main: "#2196F3",
            contrastText: "#fff",
        },
    },
});
exports.default = Theme;
